import { setKycInfo } from '@basqet-dashboard/common/api';
import { Button, Dropdown } from '@basqet-dashboard/common/components';
import { useCountries } from '@basqet-dashboard/common/hooks';
import { useFetchKycDocuments } from '@basqet-dashboard/common/hooks/queries';
import { formatErrorMessage, kycInformationSchema } from '@basqet-dashboard/common/utils';
import { yupResolver } from '@hookform/resolvers/yup';
import PropTypes from 'prop-types';
import React from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';

const StartVerification = ({ refetchKycInfo }) => {
  const { data: countries } = useCountries();
  const { kycTypes } = useFetchKycDocuments();

  const {
    register,
    handleSubmit,
    formState: { isSubmitting, isValid, isDirty },
    errors
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(kycInformationSchema)
  });

  const setKycInformation = async (data) => {
    try {
      await setKycInfo(data);
      toast.success('KYC process started');
      refetchKycInfo();
    } catch (error) {
      formatErrorMessage(error);
    }
  };

  return (
    <>
      <div className="kyc">
        <div className="card start__verification">
          <h3 className="card__title">
            Start Account <span className="text-cursive">Verification</span>
          </h3>
          <p>
            Our payment gateway creates a safe, easy and fast way to do business with customers
            globally.
          </p>

          <form className="start__verification__form" onSubmit={handleSubmit(setKycInformation)}>
            <Dropdown
              options={kycTypes || []}
              formLabel="Select KYC type"
              placeholder="e.g Corporate Financial Institution"
              name="type"
              register={register('type')}
              error={errors?.type?.message}
            />
            <Dropdown
              options={countries || []}
              formLabel="Which country are you in?"
              placeholder="e.g Nigeria"
              name="country_id"
              register={register('country_id')}
              error={errors?.country_id.message}
            />
            <Button isLoading={isSubmitting} disabled={!isDirty || !isValid} isFull>
              Start Verification
            </Button>
          </form>
        </div>
      </div>
    </>
  );
};

StartVerification.propTypes = {
  refetchKycInfo: PropTypes.func
};

export { StartVerification };
